export const styles = {
  text: {
    marginBottom: "12px",
  },
  headerText: {
    marginBottom: "5px",
  },
};
